import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import {
  BuyAndWindEffectKeys,
  type BuyAndWinTrigger,
} from '../../../../../typings'
import { messages } from './messages'

export function suite(intl: IntlShape) {
  return create((trigger: BuyAndWinTrigger) => {
    const { $t } = intl

    group(BuyAndWindEffectKeys.TRIGGER, () => {
      try {
        const { skus, collections, minQuantity } = trigger

        omitWhen(collections.length > 0 || skus.length > 0, () => {
          test('skus', $t(messages.validation.itemsRequired), () => {
            enforce(skus.length).isGreaterThan(0)
          })

          test('collections', $t(messages.validation.itemsRequired), () => {
            enforce(collections.length).isGreaterThan(0)
          })
        })

        test(
          'minQuantity',
          $t(messages.validation.minQuantityMinValue, { value: 1 }),
          () => {
            enforce(minQuantity).gte(1)
          }
        )
      } catch {
        test('empty', () => false)
      }
    })
  })
}
